import React from 'react';
import './KinsThreadLoadingScreen.css';

const KinsThreadLoadingScreen = ({ message = "Loading your heritage journey..." }) => {
  return (
    <div className="kinsthread-loading-screen">
      <div className="loading-container">
        {/* Main Logo */}
        <div className="logo-container">
          <h1 className="kinsthread-logo">
            <span className="logo-kins">Kins</span>
            <span className="logo-thread">Thread</span>
          </h1>
        </div>

        {/* Animated Dots */}
        <div className="loading-dots">
          <div className="dot dot-1"></div>
          <div className="dot dot-2"></div>
          <div className="dot dot-3"></div>
        </div>

        {/* Loading Message */}
        <p className="loading-message">{message}</p>

        {/* Subtle Background Animation */}
        <div className="background-animation">
          <div className="floating-circle circle-1"></div>
          <div className="floating-circle circle-2"></div>
          <div className="floating-circle circle-3"></div>
        </div>
      </div>
    </div>
  );
};

export default KinsThreadLoadingScreen;


